import images from "./images";

const services = [
  {
    image: `${images.fertility_treatments}`,
    title: "Fertility Treatments",
    paragraph:
      "The Ayurvedic Clinic has been able to help many couples to realise their dream of having a baby through natural conception and supporting assisted fertility methods.",
  },
  {
    image: `${images.skin_disorders}`,
    title: "Skin Disorders",
    paragraph:
      "Find natural solutions for skin disorders using the Ayurvedic approach.",
  },
  {
    image: `${images.panchakarma}`,
    title: "Panchakarma",
    paragraph:
      "In this process the body is purified of the degenerating influence of these foreign substances thus freeing it to naturally exercise its inherent rejuvenating abilities.",
  },
  {
    image: `${images.other_disorders}`,
    title: "Other Disorders",
    paragraph:
      "Ayurveda can help with a wide range of psychological and physical issues from digestive disorders to auto-immune disorders.",
  },
  {
    image: `${images.ayurvedic_herbs}`,
    title: "Ayurvedic Herbs",
    paragraph:
      "Our herbal products are 100% natural, safe and sustainably sourced, and are faithful to ancient formulas gathered from deep knowledge.",
  },
  {
    image: `${images.consultation}`,
    title: "Consultation in Person",
    paragraph:
      "Experience genuine care and support from our doctors and their specialist team of therapists and staff in the warm embrace of the clinic.",
  },
];

const works = [
  {
    image: `${images.work_img_1}`,
  },
  {
    image: `${images.work_img_2}`,
  },
  {
    image: `${images.work_img_3}`,
  },
  {
    image: `${images.work_img_4}`,
  },
  {
    image: `${images.work_img_5}`,
  },
  {
    image: `${images.work_img_6}`,
  },
];

const work_process = [
  {
    title: "Contact Us",
    paragraph:
      "Initiate direct contact with us to discuss your desired treatment or service.",
  },
  {
    title: "Schedule Appointment",
    paragraph:
      "Book an appointment to meet with our experts and discuss your needs.",
  },
  {
    title: "In-House Treatment",
    paragraph:
      "Experience our expert treatments in the comfort of our facilities.",
  },
  {
    title: "Stay Connected",
    paragraph:
      "Maintain open communication with us to discuss any changes and your overall well-being.",
  },
];

const about_stats = [
  {
    image: `${images.stat_img_1}`,
    value: "1575",
    title: "Clients",
  },
  {
    image: `${images.stat_img_2}`,
    value: "2416",
    title: "Projects",
  },
  {
    image: `${images.stat_img_3}`,
    value: "4287",
    title: "Working Hours",
  },
  {
    image: `${images.stat_img_4}`,
    value: "287",
    title: "Awards",
  },
];

const testimonials = [
  {
    name: "Emily M.",
    post: "Software Engineer",
    paragraph:
      "I never believed in natural remedies until I experienced the magic of Ayurveda at this center. Their personalized approach and genuine care have truly transformed my life. Highly recommended!",
  },
  {
    name: "John S.",
    post: "Accountant",
    paragraph:
      "From chronic pain to renewed vitality, I owe it all to the dedicated team at this Ayurveda center. Their expertise and compassionate guidance have been a blessing on my journey to wellness.",
  },
  {
    name: "Jeniffer G.",
    post: "Marketing Manager",
    paragraph:
      "A sanctuary of healing and rejuvenation! I've tried countless therapies, but nothing compares to the holistic approach of Ayurveda practiced here. Grateful for the positive changes it's brought into my life.",
  },
];

const logos = [
  {
    image: `${images.logo_img_1}`,
  },
  {
    image: `${images.logo_img_2}`,
  },
  {
    image: `${images.logo_img_3}`,
  },
  {
    image: `${images.logo_img_4}`,
  },
  {
    image: `${images.test_img_5}`,
  },
  {
    image: `${images.test_img_6}`,
  },
];

export { services, works, work_process, about_stats, testimonials, logos };
